/**
 * @file Manages the fonts values for the theme Modern V1.
 * @author kkumari
 */export default {
  FONT_LATO_BLACK: 'LatoBlack, sans-serif',
  FONT_DOMINE_REGULAR: 'DomineRegular, serif',
  FONT_SIZE_BASE: '16px',
  FONT_SIZE_SMALL: '10px',
  FONT_SIZE_DEFAULT: '14px',
  FONT_LETTER_SPACING_DEFAULT: '1.4px',
  FONT_LINE_HEIGHT_DEFAULT: '18px',
  FONT_ICONS: 'Arial, sans-serif',
  FONT_WEIGHT_BOLD: 'bold',
  FONT_WEIGHT_NORMAL: 'normal',
  FONT_WEIGHT_900: '900',
  //Mobile values
  //H1
  FONT_SIZE_H1: '36px',
  LINE_HEIGHT_H1: '44px',
  LETTER_SPACING_H1: '1.8px',
  //H2
  FONT_SIZE_H2: '24px',
  LINE_HEIGHT_H2: '30px',
  LETTER_SPACING_H2: '1.44px',
  //H3
  FONT_SIZE_H3: '20px',
  LINE_HEIGHT_H3: '30px',
  LETTER_SPACING_H3: '1.2px',
  //H4
  FONT_SIZE_H4: '16px',
  LINE_HEIGHT_H4: '22px',
  LETTER_SPACING_H4: '1.12px',
  //H5
  FONT_SIZE_H5: '11px',
  LINE_HEIGHT_H5: '13px',
  LETTER_SPACING_H5: 'normal',
  //P
  FONT_SIZE_P: '14px',
  LINE_HEIGHT_P: '24px',
  LETTER_SPACING_P: 'normal',
  DESKTOP: {
    //Desktop values
    //H1
    FONT_SIZE_H1: '70px',
    LINE_HEIGHT_H1: '85px',
    LETTER_SPACING_H1: '4.9px',
    //H2
    FONT_SIZE_H2: '30px',
    LINE_HEIGHT_H2: '44px',
    LETTER_SPACING_H2: '2.1px',
    //H3
    FONT_SIZE_H3: '24px',
    LINE_HEIGHT_H3: '26px',
    LETTER_SPACING_H3: '1.68px',
    //H4
    FONT_SIZE_H4: '16px',
    LINE_HEIGHT_H4: '19px',
    LETTER_SPACING_H4: '1.6px',
    //H5
    FONT_SIZE_H5: '12px',
    LINE_HEIGHT_H5: '14px',
    LETTER_SPACING_H5: '0.12px',
    //P
    FONT_SIZE_P: '16px',
    LINE_HEIGHT_P: '30px',
    LETTER_SPACING_P: '0.32px'
  },
  FONT_FACES: ['LatoBlack', 'DomineRegular']
};